import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { MyScheduleDetailFunction } from '../../functions/my_schedule_detail_fn';
import { ScheduleQuery } from '../../queries/schedule_query';
import { CourseScheduleLocalDatabase } from './../../databases/course_schedule_database';

interface IScheduleDetailModel {
  schedule: any;
  displayData: any;
  calendarObj?: any;
  startDate: string;
  endDate: string;
}

interface IScheduleDetailFlag {
  courseDescriptionLong: boolean;
  isPhysicalCourse: boolean;
  isMobile: boolean;
  alreadyAdded: boolean;
}

interface IMobileWindow extends Window {
  ionic?: any;
}

export class MyScheduleDetailController {
  private flags: IScheduleDetailFlag;
  private models: IScheduleDetailModel;
  private course: any;
  private sectionLabel: string = 'Section';

  constructor(
    private $state: ng.ui.IStateService,
    private ngScheduleQuery: ScheduleQuery,
    private appConfigModel: any
  ) {}

  $onInit(): void {
    this._changeDetection();
    this.sectionLabel = this.appConfigModel.getConfigProperty('section_label') || 'Section';
  }

  $onChanges(): void {
    this._changeDetection();
  }

  refresh(): void {
    this.models = {
      schedule: this.course,
      displayData: {},
      startDate: this.course.class_start_dt.format('MMMM DD, YYYY'),
      endDate: this.course.class_end_dt.format('MMMM DD, YYYY')
    };

    this.flags = {
      courseDescriptionLong: false,
      isMobile: this.isMobilePlatform(),
      isPhysicalCourse: !this.ngScheduleQuery.courseIsNotPhysical(this.course),
      alreadyAdded: true
    };

    _4.forEach(this.models.schedule._displayData, (display: object, i: number) => {
      this.models.displayData[i] = this.getLocationLink(display);
    });
  }

  getPlatform(): 'desktop' | 'android' | 'ios' {
    if (_4.isUndefined((window as IMobileWindow).ionic)) {
      return 'desktop';
    }
    return (window as IMobileWindow).ionic.Platform.isAndroid() ? 'android' : 'ios';
  }

  isMobilePlatform(): boolean {
    return this.getPlatform() !== 'desktop';
  }

  isOnLocationClass(courseType: string): boolean {
    return courseType === 'campus';
  }
  /*
   * This is a string concatenation hack for iOS since it doesn't allow for non-http
   * links to be concatenated--it ignores them so we have to run this through university-text
   * to parse the html and fool iOS into thinking it's not a concatenated string.
   */
  getLocationLink(courseTime: any) {
    if (!_.isEmpty(courseTime.locationText) && !_.isEmpty(courseTime.locationLink[this.getPlatform()])) {
      return `<p class="text-link" ng-click="$ctrl.openLocation(courseTime)">
      ${courseTime.locationText}</p>`;
    }
    return `<p>${courseTime.locationText}</p>`;
  }

  openLocation(courseTime: any) {
    if (PlatformUtility.isAndroid()) {
      window.open(courseTime.locationLink[this.getPlatform()], '_system');
    } else {
      window.open(courseTime.locationLink[this.getPlatform()]);
    }
  }

  addToCalendar() {
    const courseCD = _4.get(this.course, '_course.cd', '');
    const courseTitle = _4.get(this.course, '_course.title', '');
    const addCalendarObject = {
      title: `${courseCD}: ${courseTitle}`,
      courses: [this.course]
    };

    this.$state.go('my.add-to-calendar', { addCalendarObject });
  }

  hasLocationURL(courseTime: any): boolean {
    return !_.isEmpty(courseTime.locationText) && !_.isEmpty(courseTime.locationLink[this.getPlatform()]);
  }

  private _changeDetection(): void {
    if (!_4.isEmpty(this.course)) {
      this.refresh();
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/components/my_schedule_detail/my_schedule_detail_controller.ts